"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledge.ragStatus.pending': '等待中',
    'knowledge.ragStatus.processing': '处理中',
    'knowledge.ragStatus.completed': '已完成',
    'knowledge.ragStatus.failed': '失败',
    'knowledge.ragStatus.not_indexed': '不适用',
};
